import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FAVICONLIGHT, ENDERECOTELEFONE, WPP, INSTAGRAM, FACEBOOK } from 'src/app/app.config';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent implements OnInit {
  version: string | undefined;
  
  faviconlight = FAVICONLIGHT;
  enderecotelefone = ENDERECOTELEFONE;
  wpp = WPP;
  instagram = INSTAGRAM;
  facebook = FACEBOOK;
  constructor(
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.http.get<{ version: string }>('/assets/version.json')
      .subscribe({
        next: data => this.version = data.version,
        error: () => this.version = undefined
      });
  }

}
